import { Component, OnInit } from '@angular/core';
import { RestorePasswordModel } from '../../../model/restorepasswordmodel';
import { Router } from '@angular/router';

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.css']
})
export class RestorePasswordComponent implements OnInit {

    restorePwdPhase: string;
    restorePwdModel: RestorePasswordModel = new RestorePasswordModel();

    constructor(private router: Router) { }

    ngOnInit() {
        this.restorePwdPhase = 'EML';
    }

    onEmailPhaseDone(restorePwdModel: RestorePasswordModel) {
        this.restorePwdModel = restorePwdModel;
        this.restorePwdPhase = 'CODE';
    }

    onCodePhaseDone(restorePwdModel: RestorePasswordModel) {
        this.restorePwdModel = restorePwdModel;
        this.restorePwdPhase = 'PWD';
    }

    onPasswordPhaseDone(restorePwdModel: RestorePasswordModel) {
        this.restorePwdModel = restorePwdModel;
        this.router.navigate(['/']);
    }

}
